import { StoreRecord, TelemetryEvent } from './types'
import { TelemetrySession } from './session'

export const TELEMETRY_INDEXES = [
  {
    key: 'id',
    name: 'event_id',
    options: {
      unique: true
    }
  },
  {
    key: 'pid',
    name: 'playback_id'
  },
  {
    key: 'cid',
    name: 'content_id'
  },
  {
    key: 'sid',
    name: 'show_id'
  },
  {
    key: 'createdAt',
    name: 'created_at'
  }
]

export const STORE_NAMES = ['video', 'audio'] as Array<'video' | 'audio'>

export const compile = <Event extends TelemetryEvent<T>, Data, T>(event: Event, session: TelemetrySession<Data>): StoreRecord<Event> => ({
  id: event.id,
  createdAt: event.time,
  type: event.type,
  pid: session.data.playbackId,
  sid: session.data.content['releaseId' as never] as string | number, // showId
  cid: session.data.content['productId' as never] as string | number, // contentId
  // @ts-expect-error: ignore
  status: (event.data?.status || event.data?.reason) || 'unknown',
  event: {
    ...event,
    data: {
      ...session.data,
      ...(event.data || {})
    }
  }
})
